module.exports = __webpack_public_path__ + "img/Elmo.6606a5fc.png";